import {
  ADMIN_ROLE,
  DISABLED_PERMISSION_VALUE,
  MEMBER_ROLE,
  UDS_ADMIN_RULE_INDEX,
  UDS_MEMBER_RULE_INDEX,
  UDS_SCHEMAS,
  UdsSchema,
} from "@/src/constants/roles-permissions.constants";
import type {
  UdsPolicyGetResponse,
  UdsPolicyRule,
  UdsPolicyUpdatePayload,
  UpdateUdsPolicyParams,
} from "@/src/models/permissions.model";
import apiClient from "@/src/services/api/axios";

const resolveSchemaName = (resourceGroup?: string): UdsSchema =>
  UDS_SCHEMAS.find((s) => s === resourceGroup) ?? "post";

const patchRules = (
  rules: ReadonlyArray<UdsPolicyRule>,
  adminEnabled: boolean,
  memberEnabled: boolean,
): ReadonlyArray<UdsPolicyRule> =>
  rules.map((rule, index) => {
    if (index === UDS_ADMIN_RULE_INDEX)
      return {
        ...rule,
        staticValue: adminEnabled ? ADMIN_ROLE : DISABLED_PERMISSION_VALUE,
      };
    if (index === UDS_MEMBER_RULE_INDEX)
      return {
        ...rule,
        staticValue: memberEnabled ? MEMBER_ROLE : DISABLED_PERMISSION_VALUE,
      };
    return rule;
  });

export const updateUdsPolicyForPermission = (
  {
    permissionItemId,
    resourceGroup,
    adminEnabled,
    memberEnabled,
  }: UpdateUdsPolicyParams,
  policyMap: Readonly<Record<string, UdsPolicyGetResponse>>,
): Promise<void> => {
  const policy = policyMap[permissionItemId];
  if (!policy) return Promise.resolve();

  const payload: UdsPolicyUpdatePayload = {
    itemId: policy.itemId,
    policyName: policy.policyName,
    policyDescription: policy.policyDescription,
    policyType: policy.policyType,
    operation: policy.operation,
    schemaName: resolveSchemaName(resourceGroup),
    schemaId: policy.schemaId,
    fieldNames: [],
    ruleGroup: {
      ...policy.ruleGroup,
      rules: patchRules(policy.ruleGroup.rules, adminEnabled, memberEnabled),
    },
    priority: policy.priority,
    isAllowPolicy: policy.isAllowPolicy,
    projectKey: process.env.EXPO_PUBLIC_X_BLOCKS_KEY ?? "",
  };

  return apiClient.post("/uds/v1/data-access/policy/update", payload);
};
